var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSnow = function SvgSnow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ELEMENT|ICON|Weather",
    clipPath: "url(#clip0_5107_207546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4213 4.32437C14.413 4.30923 14.4057 4.29357 14.3994 4.27749C14.5047 3.99566 14.5576 3.69702 14.5557 3.3962C14.5558 3.06576 14.4901 2.7386 14.3624 2.43382C14.2347 2.12905 14.0476 1.85278 13.8119 1.62113C13.332 1.14882 12.6852 0.884911 12.0118 0.886728C11.4333 0.88544 10.8714 1.08045 10.418 1.43988C9.96086 1.79416 9.64416 2.29911 9.52425 2.86493C9.39396 2.72491 9.23313 2.61682 9.05426 2.54907C8.8754 2.48132 8.68332 2.45573 8.49296 2.47429C8.27487 2.49644 8.06532 2.57076 7.88201 2.69097C7.6987 2.81118 7.54702 2.97375 7.43979 3.16494C7.35099 3.32642 7.30184 3.50669 7.29641 3.69089C7.29098 3.87508 7.32941 4.05794 7.40854 4.22436L7.40541 4.23061C6.91107 4.25724 6.44529 4.47058 6.10224 4.82751C5.75336 5.18894 5.56152 5.67363 5.56855 6.17592C5.57557 6.6782 5.78089 7.15734 6.13974 7.50887C6.5085 7.87138 7.00227 8.07139 7.51792 8.07139H15.037C15.5525 8.07281 16.0478 7.87065 16.4152 7.50887C16.5956 7.33145 16.739 7.11987 16.8368 6.88647C16.9347 6.65307 16.9851 6.40252 16.9851 6.14944C16.9851 5.89636 16.9347 5.64581 16.8368 5.41241C16.739 5.17901 16.5956 4.96743 16.4152 4.79001C16.1921 4.57039 15.9195 4.40752 15.6204 4.31508C15.3213 4.22263 15.0044 4.20331 14.6963 4.25874C14.6682 4.25874 14.6401 4.26499 14.612 4.27124C14.5471 4.28367 14.4833 4.30144 14.4213 4.32437Z",
    fill: "#6B7785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69293 5.22515C3.7013 5.20898 3.70861 5.19228 3.7148 5.17515C3.6027 4.87857 3.54551 4.56405 3.54605 4.24699C3.54559 3.898 3.61473 3.55241 3.74941 3.23046C3.8841 2.9085 4.08163 2.61663 4.33045 2.37191C4.8374 1.87168 5.52146 1.59199 6.23366 1.59376C6.84618 1.59376 7.43683 1.80002 7.9181 2.18128C8.3987 2.55477 8.73186 3.08606 8.85876 3.68134C8.99644 3.5342 9.16616 3.42073 9.35476 3.34974C9.54335 3.27874 9.74577 3.25213 9.9463 3.27195C10.1765 3.29528 10.3978 3.37361 10.5914 3.50033C10.785 3.62706 10.9453 3.79846 11.0588 4.0001C11.1523 4.17078 11.2039 4.36122 11.2093 4.55574C11.2148 4.75025 11.1739 4.94327 11.0901 5.1189L11.0964 5.12515C11.6181 5.15379 12.1096 5.37941 12.4714 5.75643C12.8395 6.13765 13.0419 6.64903 13.0343 7.17892C13.0267 7.70881 12.8097 8.21417 12.4308 8.58466C12.0428 8.96716 11.5193 9.18061 10.9745 9.17844H3.03978C2.49605 9.17979 1.97379 8.96639 1.58659 8.58466C1.39591 8.3976 1.24444 8.17439 1.14104 7.92809C1.03763 7.68179 0.984375 7.41735 0.984375 7.15023C0.984375 6.88311 1.03763 6.61867 1.14104 6.37237C1.24444 6.12607 1.39591 5.90287 1.58659 5.7158C1.82162 5.48377 2.10892 5.31157 2.42434 5.21368C2.73976 5.11579 3.07407 5.09508 3.39917 5.15328L3.49292 5.1689C3.55855 5.1814 3.62418 5.20015 3.6898 5.22515H3.69293Z",
    fill: "#9AA5AF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 366",
    cx: 3.70392,
    cy: 13.1492,
    r: 0.6922,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 367",
    cx: 7.00861,
    cy: 15.2469,
    r: 0.6922,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 368",
    cx: 6.3172,
    cy: 10.8817,
    r: 0.6922,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 369",
    cx: 14.9871,
    cy: 13.1492,
    r: 0.6922,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 370",
    cx: 9.74493,
    cy: 13.1492,
    r: 0.6922,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 372",
    cx: 11.9676,
    cy: 10.8817,
    r: 0.6922,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 374",
    cx: 11.9676,
    cy: 15.2469,
    r: 0.6922,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5107_207546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.984375 0.470703)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSnow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "snow.6301128bb53a2b3fcfdbc25a8f64ba69.svg";